module.exports = __webpack_public_path__ + "img/sida.e66818d7.svg";